






































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer, safetyAndEnvironmentAssessmentServer } from '@/api/installServer';
import AddDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/addDialog.vue';
import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';
import AssessmentPageComponent from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/assessmentPageComponent.vue';
import DepartmentsAndOffices from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/departmentsAndOffices.vue';
import QuarterlyAssessment from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/quarterlyAssessment.vue';

@Component({
  components: { QuarterlyAssessment, DepartmentsAndOffices, AssessmentPageComponent, ViewDialog, AddDialog, CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class SafetyAndEnvironmentAssessment extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  private editRoleFlag: any = 1; // 控制显示 考核 页面
  private row: any = {}; // 控制显示 编辑 页面
  total = 0; // 总共多少条数据

  // 表单数据对象
  formData: any = {
    assessCycleUnit: '',
    assessContent: '',
  };
  // table 数据对象
  tableData: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [
    {
      name: '月度',
    },
    {
      name: '季度',
    },
    {
      name: '年度',
    },
  ];

  // 职务
  spacePostByAuthOptions: any = [];

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取分页数据
    this.getPageData();
    this.getSpacePostByAuth();
  }

  // 创建开始点击事件
  createExam(type: any, data?: any) {
    const detailsDialog: any = 'detailsDialog';
    const detailsDialogRef: any = this.$refs[detailsDialog];
    detailsDialogRef.showAddDialog(type, data);
  }

  // 查看
  viewManagement(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    if (data.assessCycleUnit === '季度') {
      this.editRoleFlag = 4; // 进入月度页面
    }
    if (data.assessCycleUnit === '月度') {
      this.editRoleFlag = 3; // 进入月度页面
    }
  }

  // 考核
  assessmentPage(data: any) {
    this.row = data; // 将该行 id 传递到编辑页面
    this.editRoleFlag = 2; // 进入编辑页面
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    // 发起接口请求，获取分页数据
    safetyAndEnvironmentAssessmentServer
      .getSafetyAndEnvironmentList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        assessCycleUnit: this.formData.assessCycleUnit ? this.formData.assessCycleUnit : null,
        assessContent: this.formData.assessContent ? this.formData.assessContent : null,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取职务数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpacePostByAuth() {
    // 发起接口请求，获取分页数据
    performanceServer
      .getSpacePostByAuth({})
      .then((res: any) => {
        // this.spacePostByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      assessCycleUnit: '',
      assessContent: '',
    };
    this.getPageData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: boolean): string => {
      if (state) {
        return 'tag-green';
      } else {
        return 'tag-red';
      }
    };
  }

  private handleMenuEditResponse() {
    this.editRoleFlag = 1;
    this.getPageData();
  }
}
